import React, { useState } from "react";
import { Menu, ChevronDown, LogOut, User } from "lucide-react";
import userStore from "../utils/UserStore";

const TopBar = ({ navigateTo, activePage, isSidebarOpen, toggleSidebar }) => {
    const [showUserDropdown, setShowUserDropdown] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("activePage");
        userStore.clearUser();
        window.location.reload();
    };

    return (
        <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between h-16 flex-shrink-0 sticky top-0 z-50">
            {/* Left Side - Menu Button and Title */}
            <div className="flex items-center">
                <button onClick={toggleSidebar} className="p-2 hover:bg-gray-100 rounded-lg mr-3 transition-colors">
                    <Menu className="w-5 h-5 text-gray-600" />
                </button>
                <img src="https://cdn.prod.website-files.com/63ca9a05fdc83042565f605c/698c18ae30bcf7abaa8b4a33_applogo.svg" alt="Logo" className="w-40 h-40" />
            </div>

            {/* Right Side - User Profile */}
            <div className="relative">
                <div className="flex items-center">
                    {/* User Email */}
                    <span className="text-sm text-gray-600 mr-3">{userStore.getUser()?.email || "notify@deck.in"}</span>

                    {/* User Avatar and Dropdown */}
                    <button onClick={() => setShowUserDropdown(!showUserDropdown)} className="flex items-center space-x-2 text-gray-800 px-3 py-2 rounded-lg transition-colors">
                        <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center text-sm font-medium">{userStore.getUser()?.email?.charAt(0).toUpperCase() || "N"}</div>
                        <ChevronDown className="w-4 h-4" />
                    </button>

                    {/* Dropdown Menu */}
                    {showUserDropdown && (
                        <>
                            {/* Backdrop to close dropdown when clicked outside */}
                            <div className="fixed inset-0 z-40" onClick={() => setShowUserDropdown(false)} />
                            <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                                <div className="px-4 py-2 border-b border-gray-100">
                                    <p className="text-sm font-medium text-gray-900">{userStore.getUser()?.email || "notify@deck.in"}</p>
                                    <p className="text-xs text-gray-500">{userStore.isDemoUser() ? "Demo User" : "Administrator"}</p>
                                </div>

                                <hr className="my-1" />

                                <button onClick={handleLogout} className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center">
                                    <LogOut className="w-4 h-4 mr-2" />
                                    Logout
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default TopBar;
